/* eslint-disable import/prefer-default-export */

import { FormFieldProps } from '@Constants/interface/FormInterface';

export const multiStepGoalTitle: {
  id: number;
  name: string;
  value: 'goal' | 'assignGoals';
}[] = [
  { id: 1, name: 'Goal', value: 'goal' },
  { id: 2, name: 'Assign Goals', value: 'assignGoals' },
];

export const multiStepProvincialMinistryTitle: {
  id: number;
  name: string;
  value: 'ministries' | 'department';
}[] = [
  { id: 1, name: 'Ministries', value: 'ministries' },
  { id: 2, name: 'Department', value: 'department' },
];

export const provincialSummaryFormFields: FormFieldProps[] = [
  {
    label: 'Description',
    inputType: 'text',
    type: 'textArea',
    className: ' naxatw-min-h-[6.5rem]',
    placeholder: 'Description',
    id: 'description',
    name: 'description',
    required: true,
    isVisible: true,
  },
  {
    id: 'capital',
    label: 'Capital',
    inputType: 'text',
    type: 'input',
    placeholder: 'Capital',
    name: 'capital',
    required: true,
    isVisible: true,
  },
  {
    id: 'assembly',
    label: 'Provincial Assembly',
    inputType: 'text',
    type: 'input',
    placeholder: 'Provincial Assembly',
    name: 'Provincial Assembly',
    required: true,
    isVisible: true,
  },
  {
    id: 'incumbent',
    label: 'Chief Minister (Political Party)',
    inputType: 'text',
    type: 'input',
    placeholder: 'Chief Minister (Political Party)',
    name: 'Incumbent',
    required: true,
    isVisible: true,
  },
  {
    id: 'secretary',
    label: 'Principal Secretary',
    inputType: 'text',
    type: 'input',
    placeholder: 'Principal Secretary',
    name: 'Principal Secretary',
    required: true,
    isVisible: true,
  },
  {
    id: 'spokeperson',
    label: 'Speaker',
    inputType: 'text',
    type: 'input',
    placeholder: 'Speaker',
    name: 'Speaker',
    required: true,
    isVisible: true,
  },
  {
    id: 'no_of_ministries',
    label: 'Number of Ministries',
    inputType: 'text',
    type: 'input',
    placeholder: 'Number of Ministries',
    name: 'Number of Ministries',
    required: true,
    isVisible: true,
  },
  {
    id: 'update',
    label: 'Updates',
    className: ' naxatw-min-h-[6.5rem]',
    inputType: 'text',
    type: 'tiptap-editor',
    placeholder: 'Updates',
    name: 'update',
    required: true,
    isVisible: true,
    editable: true,
  },
];

export const includeProvinicialMinstry = [
  'Sudurpashchim Province',
  'Gandaki Province',
  'Koshi Province',
  'Lumbini Province',
  'Karnali Province',
  'Madhesh Province',
  'Bagmati Province',
  'Federal',
];

export const includeAllProvincial = [
  'Lumbini Province',
  'Karnali Province',
  'Madhesh Province',
];

export function getFiscalYearOptions(noOfYears: number = 10) {
  const date = new Date();
  const currentDay = date.getDate();
  const currentMonth = date.getMonth();
  let currentYear = date.getFullYear();

  const years = [];

  // new fiscal year start from the month of july 16 for each new fiscal year
  // increase current year if month is july
  if (currentMonth === 6 && currentDay >= 16) {
    currentYear += 1;
  }
  // increase current year from the month of August
  if (currentMonth > 6) {
    currentYear += 1;
  }

  for (let i = 1; i <= noOfYears; i++) {
    const startYear = currentYear - i;
    const endYear = startYear + 1;
    years.push({
      label: `${startYear}/${String(endYear).slice(2)}`,
      value: `${startYear}/${endYear}`,
    });
  }
  return years;
}

export const getPermissionAddByTypeProps = (type: string | undefined) => {
  switch (type) {
    case 'summary':
      return 'Can add federal info';
    case 'goal':
      return 'Can add provincial goal';
    case 'ministry':
      return 'Can add unit ministry';
    default:
      return '';
  }
};

export const getPermissionChangeByTypeProps = (type: string | undefined) => {
  switch (type) {
    case 'summary':
      return 'Can change federal info';
    case 'goal':
      return 'Can change provincial goal';
    case 'ministry':
      return 'Can add unit ministry';
    default:
      return '';
  }
};
